<template>
  <div class="people-recognition">
    <div
      v-if="!faceList.length"
      class="empty"
    >
      <img :src="imageError">
      <h6>此视频暂无人物识别信息</h6>
    </div>
    <div v-else>
      <div class="face-detail">
        <div class="face-name">
          {{ currentFaceName }}
        </div>
        <div class="face-line">
          <el-tooltip
            v-for="(item, index) in faceLineList"
            :key="index"
            effect="dark"
            :content="formatDuration(item.time)"
            placement="top"
          >
            <div
              class="face-line-item"
              :style="{ left: item.left }"
              @click="handlePlay(item)"
            />
          </el-tooltip>
        </div>
      </div>
      <div class="label-item">
        <span class="label-des">人物</span>
        <div class="label-box">
          <el-tag
            v-for="(item, index) in faceList"
            :key="index"
            :class="{ dark: currentFaceName === item.name }"
            @click.native="selectFace(item)"
          >
            {{ item.name }}
          </el-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeopleRecognition',
  data() {
    return {
      imageError: require('@assets/imgs/jlxk/video-detail-error.png'),
      faceList: [],
      faceLineList: [], // 人物出现时间线上面时间点的列表。数据格式：[{left: '50px', time: '11.252'}, ...]
      currentFaceName: '' // 当前人物名
    }
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  computed: {},
  created() {},
  methods: {
    formatDuration(duration) {
      let res = ''
      let hour, minute, second
      hour = Math.floor(duration / 3600) % 60
      minute = Math.floor(duration / 60) % 60
      second = Math.floor(duration) % 60
      if (hour !== 0) {
        res = hour + ':' + (minute < 10 ? '0' + minute : minute) + ':' + second
      } else {
        res =
          (minute !== 0 ? minute : '00') +
          ':' +
          (second < 10 ? '0' + second : second)
      }
      return res
    },
    selectFace(face) {
      if (face.name === this.currentFaceName) return true
      this.currentFaceName = face.name
      this.faceLineList = []
      face.info.forEach(item => {
        let obj = {}
        obj.time = item.startTime
        obj.left = (item.startTime / this.detail.duration) * 400 + 'px'
        this.faceLineList.push(obj)
      })
    },
    handlePlay(face) {
      this.$emit('handlePlay', parseFloat(face.time))
    }
  },
  watch: {
    detail: {
      handler(newVal) {
        if (
          JSON.stringify(newVal) === '{}' ||
          !newVal.faceList ||
          newVal.faceList.length === 0
        ) {
          this.faceList = []
          return false
        }
        this.faceList = this.detail.faceList
        if (this.faceList.length) {
          this.selectFace(this.faceList[0])
        }
      }
    },
    deep: true,
    immediate: true
  }
}
</script>

<style lang="scss" scoped>
.people-recognition {
  margin-top: 20px;
  .face-detail {
    height: 60px;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    .face-name {
      font-size: 13px;
      margin-left: 22px;
    }
    .face-line {
      position: relative;
      width: 425px;
      height: 9px;
      margin-left: 14px;
      background: #dfdfdf;
      .face-line-item {
        position: absolute;
        top: 0;
        width: 3px;
        height: 10px;
        background: #cacaca;
        cursor: pointer;
      }
      .face-line-item:hover {
        background: #aaaaaa;
      }
    }
  }
  .label-item {
    margin: 20px 0;
    display: flex;
    .label-des {
      width: 3em;
      flex: 0 0 auto;
      line-height: 30px;
      text-align: right;
      display: flex;
      font-size: 14px;
      justify-content: flex-end;
    }
    .label-des::after {
      content: "：";
    }
    .label-box {
      display: flex;
      flex-wrap: wrap;
      cursor: pointer;
      .el-tag {
        margin: 0 5px 5px 0;
        background: #ffffff;
        border: 1px solid #e7e7e7;
        border-radius: 5px;
        font-size: 13px;
        color: #454647;
        &.dark {
          border-color: #4497ec;
          color: #4497ec;
        }
      }
    }
  }
}
</style>
